// src/api/user.js
import request from '@/utils/request'

// 获取用户列表接口
export const getUserList = () => {
  return request({
    url: '/loupanindex',
    method: 'post',
  })
}

// 提交用户信息接口
export const submitUserInfo = (data) => {
  return request({
    url: '/save',
    method: 'post',
    data
  })
}

// 微信授权接口
export const weixinAuth = (data) => {
  return request({
    url: '/auth',
    method: 'post',
    data
  })
}